

import {
    ClientCompanyContact,
    ClientCompanyContactQueryQueryResult,
    CreateClientCompanyContactMutation,
    UpdateClientCompanyContactMutation,
    UpdateClientCompanyContactMutationResult,
    useClientCompanyContactQueryQuery,
    useCreateClientCompanyContactMutation, useUpdateClientCompanyContactMutation
} from "../../generated/graphql";
import React, {useCallback} from "react";
import {useParams} from "react-router";
import {useDiaEditor} from "../../components/DiaEditor";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import {ContactForm} from "./Form";
import * as yup from "yup";


const contactRelationships = {
    'clientCompany':'connect',
    'salesTeam':'connect'
};
const schema = yup.object().shape({
    salesTeam: yup.object().required()
});

function makeBlankValues():ClientCompanyContact  {
    return {
        id: 'new',
        title: '',
        email: '',
        comments: '',
        is_marketing: false,
        is_sales: true,
        name: '',
        job_sheet_info: '',
        phone: '',
        phone_alt: '',
        clientCompany: null,
        salesTeam: null
    };
}

export function ContactEditor() {
    const params = useParams();
    const isNew = (params.id=='new');
    const query = useClientCompanyContactQueryQuery({variables:{id:params.id},skip:isNew});
    const [saveMutation,saveResult] = useUpdateClientCompanyContactMutation();
    const [createMutation,createResult] = useCreateClientCompanyContactMutation();
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[]);
    const create = useCallback(({values})=>{
        return createMutation({variables:{input:values}});
    },[]);
    const getValue = useCallback((result:ClientCompanyContactQueryQueryResult)=>{
        console.log('LOADED',result?.data);
        return result?.data?.clientCompanyContact;
    },[]);
    const getSaveValue = useCallback((result:UpdateClientCompanyContactMutationResult)=>{
        console.log('UCCC',result?.data?.updateClientCompanyContact);
        return result?.data?.updateClientCompanyContact;
    },[]);
    const getCreateRedirect = useCallback(({data,baseUrl})=>{
        return baseUrl+(data?.data?.createClientCompanyContact?.id);
    },[]);
    const data = useDiaEditor<ClientCompanyContact,ClientCompanyContactQueryQueryResult,CreateClientCompanyContactMutation,UpdateClientCompanyContactMutation>({save,saveResult,create,createResult,query:query,
        relationships:contactRelationships,
        baseUrl:'/contacts/',
        blankValues:makeBlankValues,
        label:'Contacts',
        permission:'contacts',
        getValue:getValue,
        getSaveValue:getSaveValue,
        validationSchema:schema,
        getCreateRedirect:getCreateRedirect
    });
    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    if(data.form.status!='ready') {
        return <WaitSpinner variant="panel"/>;
    }
    return <>
        {data.confirmation}
        <ContactForm diaForm={data.form} />
    </>;
}